import { requestApi } from 'api/Api';

import { showAlert } from 'components/shared/Alert/Alert';

export const getVendors = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/vendors/get',
    params,
    onError: () =>
      showAlert({
        title: "Couldn't load vendors",
        color: 'danger'
      })
  });

export const getVendorIntegrationTypes = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/integration_types/list',
    params,
    onError: () =>
      showAlert({
        title: "Couldn't load integration types",
        color: 'danger'
      })
  });

export const createVendorIntegrationType = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/integration_types/create',
    params
  });

export const createVendor = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/vendors/create',
    params
  });

export const updateVendor = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/admin/vendors/update',
    params
  });
